module.exports = __webpack_public_path__ + "img/insulation.6b19fbcd.jpg";